
















































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { uniqueId, cloneDeep } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  BODY_HEIGHT,
  Col,
  DataTableHeader
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'

export interface TableItem {
  isSelected: boolean
  id: number
  key: string
  name: string
  nameKana: string
  note1: string
  note2: string
  note3: string
  revision: number
}

export const defaultTableItem: TableItem = {
  isSelected: false,
  id: 0,
  key: '',
  name: '',
  nameKana: '',
  note1: '',
  note2: '',
  note3: '',
  revision: 0
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'key',
        headerText: 'コードキー'
      }
    ]
  },
  {
    width: '70',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'name',
        headerText: 'コードキー名'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class CodeKeyTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  items!: TableItem[]

  @Prop({
    type: Number,
    default: BODY_HEIGHT
  })
  height!: number

  @Prop({
    type: Boolean,
    default: true
  })
  isSystemCode!: boolean

  get radioName(): string {
    return uniqueId('code-key-table-radio')
  }

  get showCols(): Col[] {
    if (this.isSystemCode) return COLS

    const cols = cloneDeep(COLS)
    cols[2].items[0].headerText = 'パラメーターキー'
    cols[3].items[0].headerText = 'パラメーターキー名'
    return cols
  }

  @Emit('dblclick:row')
  onDoubleClickTableRow(): void {}

  @Emit('select:item')
  onClickTableRow(index: number): string {
    return this.items[index].key
  }
}
